import React, { createContext, useEffect, useState } from "react";
import api from "../services/api";

export const AuthContext = createContext({});

const STORAGE_KEY = "@authUser";
const ACCESS_TOKEN = "@accessToken";

const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const stored = localStorage.getItem(STORAGE_KEY);
    const storedToken = localStorage.getItem(ACCESS_TOKEN);

    if (stored) {
      const userStored = JSON.parse(stored);
      setUser(userStored);
      setIsLoggedIn(true);
    }

    if (storedToken) {
      const { token } = JSON.parse(storedToken);
      setToken(token);
    }

    setLoading(false);
  }, []);

  async function signIn({ email, password }) {
    const response = await api.post("/user/login/", {
      email,
      pwd: password,
    });

    const { access_token, user } = response.data;

    if (typeof window !== "undefined") {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(user)
      );

      localStorage.setItem(
        ACCESS_TOKEN,
        JSON.stringify({
          token: access_token
        })
      );
    }

    setToken(access_token);
    setUser(user);
    setIsLoggedIn(true);
  }

  function updateUser(user) {
    setUser(user);

    if (typeof window !== "undefined") {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(user)
      );
    }
  }

  function signOut(callback) {
    if (typeof window !== "undefined") {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(ACCESS_TOKEN);
    }

    setToken(null);
    setUser(null);
    setIsLoggedIn(false);

    if (callback) callback();
  }

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        user,
        token,
        loading,
        signIn,
        signOut,
        updateUser
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthProvider };
